<template>
  <div class="hotel-map-component"></div>
</template>

<script>
export default {
  props: {
    hotel: {
      type: Object,
      required: true
    },
    dialogIsOpen: {
      type: Boolean,
      required: true,
    }
  },

  methods: {
    initMap() {
      const latLng = { lat: +this.hotel.latitude, lng: +this.hotel.longitude };
      const map = new google.maps.Map(this.$el, {
        zoom: 15,
        center: latLng,
        disableDefaultUI: true,
      });
      new google.maps.Marker({
        position: latLng,
        map,
        label: {
          text: this.hotel.name,
          color: 'black',
          fontSize: "20px"
        },
      });
    },
  },

  watch: {
    dialogIsOpen() {
      this.initMap();
    }
  },

  mounted() {
    this.initMap();
  }
}
</script>

<style lang="scss" scoped>
.hotel-map-component {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
